<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed } from 'vue';
import type { TreeBase, TreeNodeSelectSettings } from '@/composables/useTreeNode';
import type { ICellRendererParams } from 'ag-grid-community';
import TreeNodeSelectList from '@/components/common/TreeNodeSelectList.vue';

type ExtendedParams = ICellRendererParams<any, void> & {
    selectedValues: string[];
    options: TreeBase[];
    selectOptionTitle: string;
    settings: TreeNodeSelectSettings;
    change: (changedNodes: (TreeBase | null)[], newSelectedState: string[]) => void;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const options = computed(() => props.params.options);
const selectedValues = computed(() => props.params.selectedValues);
const selectOptionTitle = computed(() => props.params.selectOptionTitle);
const settings = computed(() => props.params.settings);

function closePopup():void {
    props.params.api.stopEditing();
}

function change(changedNodes: (TreeBase | null)[], newSelectedState: string[]): void {
    props.params.change(changedNodes, newSelectedState);

    closePopup();
}
</script>

<template>
    <TreeNodeSelectList
        class="width-100 dropdown-menu"
        :options="options"
        :select-option-title="selectOptionTitle"
        :selected-values="selectedValues"
        :settings="settings"
        @change="change"
    />
</template>
